export const initLayout = () => {
    const subnavElement = $('#subnav');

    const moreElement = $('#menu-more');
    const moreButtonElement = $('#menu-more > button');

    const closeElement = $('#menu-close');
    const closeButtonElement = $('#menu-close > button');

    moreButtonElement.on("click", () => {
        moreElement.css('display', 'none');
        closeElement.css('display', '');
        closeElement.addClass('header__action--show')
        subnavElement.addClass('header__overflow--show');
    });

    closeButtonElement.on("click", () => {
        closeElement.css('display', 'none');
        moreElement.css('display', '');
        closeElement.removeClass('header__action--show')
        subnavElement.removeClass('header__overflow--show');
    });
}
